import React, { FC } from 'react';
import { isMotorizmus } from '../utils';
import { SrWidget } from './SrWidget';

export interface SrWidgetLiveMatchTrackerProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
    sportId: string;
    momentumDisabled: boolean;
}

export const SrWidgetLiveMatchTracker: FC<SrWidgetLiveMatchTrackerProps> = ({
    matchId,
    sportId,
    momentumDisabled,
    ...props
}) => {
    const widgetProps = {
        matchId: matchId,
        stageId: isMotorizmus(parseInt(sportId)) ? matchId : null,
        scoreboard: 'disable',
        tabsPosition: 'disable',
        detailedScoreboard: 'disable',
        collapseTo: 'track',
        momentum: momentumDisabled ? 'disable' : 'compact',
        hideExpand: true,
        disableAds: true,
        goalBannerImage: false
    };
    return <SrWidget widgetName="match.lmtPlus" widgetProps={widgetProps} {...props} />;
};
